// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"f41185b1","167":"fc83570a","183":"47143888","211":"dd7c272d","240":"240c4edd","655":"2cc7bd9f","725":"0adabdcd","794":"81f0dc21","899":"e12b7d78","981":"56ce60ef"}[chunkId] + ".chunk.js";
};